import React, { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";

function SerashBox() {
  let Niveget = useNavigate();
  let [Serashterm, SetSerashterm] = useState("");
  let [suggestions, setsuggestions] = useState([]);
  let locaion = useLocation();

  let handelSubmit = (e) => {
    e.preventDefault();
    if (Serashterm.trim()) {
      Niveget(`/serash?query=${encodeURIComponent(Serashterm.trim())}`);
    }
    setsuggestions([]);
  };

  useEffect(() => {
    let fetchsuggestions = async () => {
      if (!Serashterm.trim()) {
        setsuggestions([]);
        return;
      }

      try {
        let res = await fetch(
          `https://dummyjson.com/products/search?q=${Serashterm}`
        );
        let data = await res.json();
        setsuggestions(data.products.slice(0, 5) || []);
      } catch (error) {
        console.error("SearshError", error);
        setsuggestions([]);
      }
    };

    let dodom = setTimeout(() => {
      fetchsuggestions();
    }, 300);
    return () => clearTimeout(dodom);
  }, [Serashterm]);

  useEffect(() => {
    setsuggestions([]);
  }, [locaion]);

  return (
    <div className="SerashBox_Container">
      <form onSubmit={handelSubmit} className="Search-box">
        <input
          type="text"
          name="Search"
          placeholder="Search For Productes"
          onChange={(e) => SetSerashterm(e.target.value)}
          autoComplete="off"
        ></input>
        <button type="Submit">
          <FaSearch />
        </button>
      </form>
      {suggestions.length > 0 && (
        <ul className="suggestions">
          {suggestions.map((item) => (
            <Link to={`/products/${item.id}`}>
              <li key={item.id}>
                <img src={item.images[0]} alt="" />
                <span>{item.title}</span>
              </li>
            </Link>
          ))}
        </ul>
      )}
    </div>
  );
}

export default SerashBox;
